module.exports = __webpack_public_path__ + "img/air_empty.34c5bfc8.svg";